module.exports = __webpack_public_path__ + "img/login.6a0ebe7c.png";